import React, { memo } from "react";
import { Position } from "@xyflow/react";
import NodeWrapper from "./NodeWrapper";
import { LocalOffer } from "@mui/icons-material";

const TagCheckNode = memo(({ id, data, isConnectable, selected }) => {
  const tagName = data?.tag?.name || "Nenhuma tag";
  const tagColor = data?.tag?.color || "#9e9e9e";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<LocalOffer />}
      title="Verificar Tag"
      color="#37474f"
      bgColor="#ECEFF1"
      isConnectable={isConnectable}
      selected={selected}
      minWidth={210}
      handles={[
        { id: "a", type: "source", position: Position.Right, style: { top: "60%" } },
        { id: "b", type: "source", position: Position.Right, style: { top: "85%" } },
      ]}
    >
      {/* Tag selecionada */}
      <div style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        background: "#fff",
        border: "1px solid #e0e0e0",
        borderRadius: 12,
        padding: "2px 10px",
        marginBottom: 4,
      }}>
        <span style={{
          width: 8, height: 8, borderRadius: "50%",
          backgroundColor: tagColor, display: "inline-block",
        }} />
        <span style={{ fontSize: 11, color: "#37474F", fontWeight: 500 }}>
          {tagName}
        </span>
      </div>

      {/* Labels das saidas */}
      <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 6 }}>
        <div style={{ display: "flex", justifyContent: "flex-end", paddingRight: 4 }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#4caf50", borderRadius: 4,
            padding: "2px 10px", letterSpacing: "0.04em",
          }}>
            TEM
          </span>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", paddingRight: 4 }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#ef5350", borderRadius: 4,
            padding: "2px 10px", letterSpacing: "0.04em",
          }}>
            NAO TEM
          </span>
        </div>
      </div>
    </NodeWrapper>
  );
});

TagCheckNode.displayName = "TagCheckNode";
export default TagCheckNode;
